<template>
    <div
        class="inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-[2px] text-content-md"
        :class="`ds-badge-${variant}`"
    >
        <DsIcon
            v-if="icon"
            :icon
            size="sm"
        />
        <span class="text-content-primary">
            {{ text }}
        </span>
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';

export interface BadgeCoreProps {
    text: string;
    variant: 'success' | 'active' | 'error' | 'inactive' | 'warning';
    icon?: string;
}

defineProps<BadgeCoreProps>();
</script>

<style scoped lang="scss">
.ds-badge-active {
    @apply bg-ds-blue-100;

    :deep(.ds-icon-frame) {
        color: theme('colors.ds.blue.500');
    }
}

.ds-badge-inactive {
    @apply bg-ds-gray-200;

    :deep(.ds-icon-frame) {
        color: theme('colors.ds.gray.800');
    }
}

.ds-badge-success {
    @apply bg-ds-green-100;

    :deep(.ds-icon-frame) {
        color: theme('colors.ds.green.700');
    }
}

.ds-badge-warning {
    @apply bg-ds-yellow-100;

    :deep(.ds-icon-frame) {
        color: theme('colors.ds.yellow.500');
    }
}

.ds-badge-error {
    @apply bg-ds-red-100;

    :deep(.ds-icon-frame) {
        color: theme('colors.ds.red.600');
    }
}
</style>
